import { motion } from "framer-motion";
import { SPECS } from "@/content";
import {
  ShieldCheck,
  Wind,
  DoorClosed,
  Droplets,
  Zap,
  Layers,
  Square,
  Sparkles,
} from "lucide-react";

const ICONS = [Wind, ShieldCheck, DoorClosed, Droplets, Zap, Layers, Square, Sparkles];

export default function Specs() {
  return (
    <section
      id="specs"
      data-testid="section-specs"
      className="relative py-16 lg:py-20 bg-[#D9D0BE]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mx-auto mb-8 lg:mb-10 text-center"
        >
          <span
            className="block text-xs text-brand-accent mb-3"
            data-testid="specs-kicker"
          >
            {SPECS.kicker}
          </span>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl text-brand-ink mb-4 leading-tight font-sans"
            data-testid="specs-headline"
          >
            {SPECS.headline}
          </h2>
          <p className="mt-[30px] text-sm lg:text-base text-brand-mute leading-loose">
            {SPECS.description}
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-brand-border rounded-2xl overflow-hidden">
          {SPECS.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.article
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
                className="bg-brand-cream/92 p-5 text-center lg:p-6 group hover:bg-brand-olive transition-colors duration-500 lg:text-right"
                data-testid={`spec-card-${i}`}
              >
                <Icon
                  size={32}
                  strokeWidth={1.2}
                  className="mx-auto mb-4 text-brand-olive transition-colors duration-500 group-hover:text-brand-accent lg:mx-0"
                />
                <h3 className="text-base lg:text-lg text-brand-ink group-hover:text-brand-cream mb-2 font-sans transition-colors duration-500">
                  {item.title}
                </h3>
                <p className="text-xs lg:text-sm text-brand-mute group-hover:text-brand-cream/80 leading-relaxed transition-colors duration-500">
                  {item.desc}
                </p>
                <div className="mt-4 text-xs text-brand-accent font-medium">
                  {String(i + 1).padStart(2, "0")} —
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
